{
  "zh-CN": {
    "headlines": {
      "vehiclePlaque": {
        "title": "命名铭牌"
      },
      "vehicleOverview": {
        "paints": "%{model} 涂装",
        "location": "舰船在哪里？",
        "picture": "舰船图片"
      },
      "vehicleLog": {
        "create": "新日志条目",
        "edit": "编辑日志条目",
        "public": "舰长日志：%{vehicle}"
      },
      "hangarShare": "分享链接",
      "locations": {
        "index": "地点",
        "places": "所有地点"
      },
      "admin": {
        "locations": {
          "index": "地点"
        },
        "blueprints": {
          "index": "蓝图",
          "materials": "材料",
          "stats": "属性",
          "sources": "来源"
        },
        "missions": {
          "index": "任务"
        },
        "dashboard": {
          "title": "仪表板",
          "visitsPerDay": "每日访问",
          "visitsPerMonth": "每月访问",
          "mostViewedPages": "浏览最多的页面",
          "registrationsPerMonth": "每月注册数"
        },
        "models": {
          "index": "型号",
          "edit": {
            "index": "编辑型号",
            "fleetchart": "舰队图表图片",
            "positions": "乘员岗位",
            "hardpoints": "挂载点",
            "cargoAndFuel": "燃料",
            "cargoHolds": "货舱",
            "metrics": "指标",
            "prices": "价格",
            "docks": "停靠口",
            "modules": "模块",
            "paints": "涂装",
            "videos": "视频",
            "images": "图片",
            "itemPrices": "物品价格",
            "linkModule": "链接现有模块",
            "loaners": "借用船",
            "snubCrafts": "微型舰载机",
            "upgrades": "升级",
            "packages": "套餐",
            "linkUpgrade": "链接现有升级",
            "history": "修改历史"
          },
          "new": "新型号",
          "show": "型号",
          "images": "图片",
          "tableConfigurationModal": "表格配置"
        },
        "components": {
          "index": "组件",
          "new": "新组件",
          "edit": {
            "index": "编辑组件",
            "itemPrices": "物品价格",
            "history": "修改历史"
          }
        },
        "modelPaints": {
          "index": "涂装",
          "new": "新涂装",
          "edit": "编辑涂装",
          "copy": "复制涂装到飞船",
          "bulkCopy": "复制 %{count} 个涂装到飞船"
        },
        "modelModules": {
          "index": "模块",
          "new": "新模块",
          "edit": "编辑模块",
          "models": "关联型号",
          "prices": "价格",
          "hardpoints": "挂载点",
          "docks": "停靠点",
          "cargoHolds": "货舱",
          "history": "修改历史"
        },
        "unlistedModels": {
          "index": "游戏文件中没有对应条目的飞船",
          "link": "关联到目录中的飞船"
        },
        "manufacturers": {
          "index": "制造商",
          "new": "新制造商",
          "edit": {
            "index": "编辑制造商"
          }
        },
        "announcements": {
          "index": "公告",
          "new": "新建公告",
          "edit": "编辑公告",
          "deliveries": "投递情况",
          "manualPosts": "可复制的帖子"
        },
        "supporterContributions": {
          "index": "支持者贡献",
          "new": "新建支持者贡献",
          "edit": "编辑支持者贡献",
          "perMonth": "每月贡献"
        },
        "fundingGoals": {
          "index": "资金目标",
          "new": "新建资金目标",
          "edit": "编辑资金目标"
        },
        "users": {
          "index": "用户",
          "edit": "编辑用户",
          "fleets": "舰队",
          "inventories": "用户库存",
          "supporterContributions": "支持者贡献"
        },
        "vehicles": {
          "index": "载具",
          "edit": "编辑载具"
        },
        "fleets": {
          "index": "舰队",
          "edit": "编辑舰队",
          "members": "成员",
          "memberEdit": "编辑成员",
          "history": "修改历史",
          "roles": "舰队角色",
          "inventories": "舰队库存",
          "inventoryItems": "库存条目"
        },
        "fleetFidClaims": {
          "index": "舰队 ID 申领"
        },
        "destroyedFleets": {
          "index": "已删除舰队"
        },
        "admins": {
          "index": "管理员",
          "new": "新管理员",
          "edit": "编辑管理员"
        },
        "oauthApplications": {
          "index": "OAuth 应用",
          "new": "新建 OAuth 应用",
          "edit": "编辑 OAuth 应用",
          "reject": "拒绝 %{name}",
          "rejectBulk": "拒绝 %{count} 个应用"
        },
        "features": {
          "index": "功能标志",
          "show": "功能详情",
          "globalState": "全局状态",
          "groups": "群组",
          "actors": "角色",
          "selfService": "自助服务",
          "percentageOfActors": "角色百分比",
          "percentageOfTime": "时间百分比",
          "addActor": "添加角色",
          "history": "变更历史",
          "addUser": "为用户启用",
          "addFleet": "为舰队启用",
          "enabledUsers": "已启用的用户",
          "enabledFleets": "已启用的舰队"
        },
        "rsiApiStatus": {
          "index": "RSI API 状态"
        },
        "images": {
          "index": "图片"
        },
        "imports": {
          "index": "导入"
        },
        "notifications": {
          "index": "通知"
        },
        "commodities": {
          "index": "Commodities",
          "edit": {
            "index": "Edit Commodity"
          }
        },
        "equipment": {
          "index": "Equipment",
          "edit": {
            "index": "Edit Equipment",
            "itemPrices": "Item Prices"
          }
        },
        "visualTests": {
          "index": "视觉测试",
          "notifications": "通知"
        },
        "buildCompare": {
          "index": "版本对比"
        }
      },
      "welcome": "Welcome to",
      "welcomeShips": "Latest Ships",
      "welcomeImages": "Random Images",
      "ships": {
        "index": "Ships Index",
        "fleetchart": "飞船舰队图表"
      },
      "images": "Images Index",
      "stats": "统计",
      "notFound": "导航错误",
      "forbidden": "拒绝访问",
      "subscriptionRequired": "支持者功能",
      "featureNotReady": "即将推出",
      "inviteInvalid": "邀请链接无效",
      "accessDenied": "拒绝访问",
      "serverError": "服务器错误",
      "offline": "连接已断开",
      "invalidRequest": "无效请求",
      "comments": "评论",
      "login": "登录",
      "hangar": {
        "index": "我的机库",
        "preview": {
          "title": "你的机库",
          "lead": "记录你拥有的每一艘舰船——注册 FleetYards.net 账户即可免费使用。"
        },
        "alternativeNames": "别名",
        "stats": "统计",
        "public": "%{user} 的机库",
        "import": "导入",
        "wishlist": "愿望清单",
        "publicStats": "统计",
        "publicWishlist": "%{user} 的愿望清单",
        "resetIngame": "数据重置后重置游戏内飞船",
        "buybacks": "可回购承诺",
        "paints": "涂装",
        "flair": "机库装饰",
        "upgrades": "升级 / CCU",
        "equipment": "FPS 装备",
        "shipComponents": "飞船部件",
        "imports": "导入记录"
      },
      "buybackSync": "同步 RSI 可回购承诺",
      "syncExtension": "同步 RSI 机库",
      "editMyVehicle": "Edit my %{vehicle}",
      "vehicleLoadout": "%{vehicle} 的配装",
      "nameMyVehicle": "Name my %{vehicle}",
      "editGroups": "Edit Groups",
      "newVehicles": "Add Ships",
      "myVehicleAddons": "Add Modules / Upgrades for %{vehicle}",
      "myVehicleLoadouts": "%{vehicle} 的配装",
      "addToHangar": "Add \"%{model}\" to your Hangar",
      "impressum": "法律声明",
      "privacy": "隐私政策",
      "cookie": "Cookie policy",
      "requestPassword": "请求密码",
      "changePassword": "修改密码",
      "confirmAccess": "Confirm access",
      "setEmail": "设置电子邮件地址",
      "oauthAuthorize": "授权应用",
      "filterModels": "Filter Ships",
      "filterVehicles": "Filter Hangar",
      "fleets": {
        "directory": "舰队目录",
        "owners": "Owners",
        "add": "Create a new Fleet",
        "invites": "舰队邀请",
        "inviteUrls": "Invite Urls",
        "members": {
          "index": "Members",
          "worldmap": "成员世界地图",
          "starmap": "成员星图",
          "health": "成员健康检查"
        },
        "squadrons": {
          "index": "中队",
          "create": "创建中队",
          "edit": "编辑中队",
          "formDetails": "详情",
          "formAppearance": "外观",
          "formDiscord": "Discord",
          "ranks": "中队职级",
          "editMember": "编辑中队成员",
          "editRank": "编辑中队职级",
          "teams": "小队",
          "addMembers": "添加成员",
          "members": "成员"
        },
        "stats": "统计",
        "preview": {
          "title": "你的舰队",
          "lead": "把你的组织聚在一起——注册 FleetYards.net 账户即可免费使用。"
        },
        "settings": {
          "fleet": "Fleet Settings",
          "rsi": "舰队 ID 与 RSI",
          "membership": "Membership Settings",
          "roles": "舰队角色",
          "squadrons": "舰队中队",
          "allies": "舰队盟友",
          "notifications": "通知设置",
          "inAppNotifications": "应用内通知",
          "discord": "Discord",
          "calendar": "日历",
          "contracts": "合约设置",
          "features": "舰队功能"
        },
        "inviteMember": "Invite new Member",
        "calendarSubscription": "日历订阅",
        "missions": {
          "index": "任务",
          "create": "创建任务",
          "edit": "编辑任务",
          "editDetails": "详情",
          "editDescription": "描述与封面",
          "editTeams": "小队与席位",
          "teams": "小队",
          "ships": "飞船",
          "slots": "席位",
          "addTeam": "添加小队",
          "editTeam": "编辑小队",
          "addShip": "添加飞船",
          "editShip": "编辑飞船"
        },
        "events": {
          "expandShip": "增加席位",
          "index": "活动",
          "calendar": "日历",
          "create": "创建活动",
          "edit": "编辑活动",
          "editDetails": "详情",
          "editSchedule": "时间安排",
          "editSignup": "报名",
          "editDescription": "描述与封面",
          "editTeams": "小队与席位",
          "spawn": "生成活动",
          "details": "活动详情",
          "schedule": "日程",
          "settings": "设置",
          "lifecycle": "生命周期",
          "signupTitle": "报名参加",
          "yourSignup": "你的报名",
          "spawnedFrom": "由此任务生成",
          "pickTemplate": "选择任务模板",
          "unassignedSignups": "未分配的报名",
          "eventTeam": "活动小队",
          "grantRole": "授予角色",
          "editTeam": "编辑小队",
          "addTeam": "添加小队",
          "editShip": "编辑飞船",
          "addShip": "添加飞船",
          "assignSlotFor": "为 %{username} 分配席位",
          "reassignSlotFor": "为 %{username} 重新分配席位"
        },
        "memberNickname": "成员昵称",
        "editRole": "编辑角色",
        "contracts": {
          "index": "合约",
          "create": "创建合约",
          "edit": "编辑合约",
          "progress": "进度",
          "crew": "队伍",
          "items": "货物",
          "editItem": "编辑货物",
          "addItem": "添加货物",
          "views": {
            "open": "合约",
            "closed": "已结束的合约",
            "mine": "我的合约",
            "completed": "已完成的合约"
          }
        }
      },
      "hangarGroup": {
        "create": "Create Group",
        "edit": "Edit Group"
      },
      "compare": {
        "ships": "比较飞船"
      },
      "settings": {
        "account": "账户",
        "profile": "个人资料设置",
        "hangar": "机库设置",
        "privacy": "隐私设置",
        "privacySections": {
          "analytics": "使用情况分析",
          "onlineStatus": "在线状态",
          "supporters": "支持者页面"
        },
        "features": "功能标志",
        "connections": "连接",
        "oauthApplications": "OAuth 应用",
        "notifications": "通知设置",
        "verify": "Verify your RSI Account",
        "security": {
          "index": "账户安全",
          "twoFactor": "Two-factor Authentication"
        },
        "twoFactor": {
          "enable": "Enable Two-factor Authentication",
          "disable": "Disable Two-factor Authentication",
          "backupCodes": "Generate Two-Factor Backup Codes"
        },
        "calendar": "日历订阅",
        "donations": "捐赠"
      },
      "oauthApplications": {
        "new": "新建 OAuth 应用",
        "edit": "编辑 OAuth 应用"
      },
      "roadmap": "飞船路线图",
      "tools": {
        "index": "工具",
        "travelTimes": "旅行时间",
        "cargoGrids": "货物网格",
        "tradeRoutes": "贸易路线"
      },
      "rsiVerification": "Verify your RSI-Account",
      "support": "Support FleetYards.net",
      "supporters": "感谢我们的支持者",
      "appUpdate": "新版本已就绪",
      "installApp": {
        "offer": "随身携带 FleetYards",
        "ios": "安装 FleetYards"
      },
      "supportHint": {
        "hangarSync": "很高兴帮你完成了同步",
        "vehicleAdded": "你的机库在不断壮大",
        "fleetCreated": "新舰队 — 恭喜!",
        "loginMilestone": "感谢你一直以来的支持",
        "visitMilestone": "喜欢 FleetYards 吗?"
      },
      "vehicle": {
        "bulkGroupEdit": "添加/移除群组"
      },
      "pagination": {
        "count": "%{current} / %{total}"
      },
      "models": {
        "index": "型号"
      },
      "modals": {
        "models": {
          "displayOptions": "显示选项"
        }
      },
      "visualTests": {
        "overview": "概览",
        "panels": "面板",
        "buttons": "按钮",
        "media": "媒体",
        "charts": "图表",
        "blueprints": "蓝图",
        "squadrons": "中队",
        "alerts": "提示",
        "verifiedBadges": "验证徽章",
        "chips": "视觉测试 Chips",
        "events": "活动",
        "typography": "排版",
        "forms": "表单",
        "tables": "表格",
        "lists": "列表",
        "metrics": "指标",
        "states": "状态",
        "notifications": "通知",
        "dedicationPlaques": "命名铭牌",
        "syncModal": "同步弹窗",
        "buybackSyncModal": "回购同步弹窗",
        "rsiVerificationModal": "RSI 验证弹窗",
        "fleetRsiVerificationModal": "舰队 RSI 验证弹窗",
        "overlays": "浮层",
        "installPrompt": "安装提示",
        "supportHint": "支持提示",
        "notificationCenter": "通知中心",
        "themes": "主题"
      },
      "logistics": {
        "index": "Logistics",
        "inventories": "Inventories",
        "requests": "Requests",
        "newRequest": "New Request",
        "requestItems": "Items",
        "comments": "Comments",
        "inventoryItems": "Inventory Items",
        "createInventory": "Create Inventory",
        "editInventory": "Edit Inventory",
        "createItem": "Add Item",
        "deposit": "Deposit",
        "withdrawal": "Withdrawal",
        "importCsv": "Import from CSV",
        "hangarInventories": "Hangar Inventories",
        "editItem": "Edit Entry",
        "editStockItem": "Edit Item",
        "transfer": "转移库存",
        "transfers": "转移",
        "acceptTransfer": "接受转移",
        "pickItem": "选择物品",
        "crafting": "制作",
        "reportTransfer": "举报转移"
      },
      "notifications": {
        "index": "通知"
      },
      "payouts": {
        "index": "分账",
        "summary": "概要",
        "participants": "参与者",
        "entries": "记录",
        "balances": "余额",
        "transfers": "分账清单",
        "addEntry": "记一笔",
        "editEntry": "编辑记录",
        "addParticipant": "添加参与者",
        "tours": {
          "index": "行程",
          "create": "创建行程",
          "join": "加入此行程"
        },
        "declineExpense": "拒绝支出"
      },
      "relationships": {
        "user": {
          "index": "好友",
          "add": "添加好友"
        },
        "fleet": {
          "add": "添加盟友"
        }
      },
      "fleet": {
        "contractCovers": "合约封面图"
      },
      "component": {
        "temperature": "温度",
        "misfire": "故障",
        "history": "历史",
        "craftedFrom": "制造配方",
        "identity": "详情",
        "metrics": "数据",
        "requiredTags": "可装入具备以下标签的接口",
        "tags": "标签",
        "physical": "物理属性",
        "damageTaken": "承受伤害",
        "durability": "耐久性",
        "selfRepair": "自我修复",
        "distortion": "扭曲",
        "splineJump": "轨道跃迁"
      },
      "commodity": {
        "priceHistory": "价格历史",
        "identity": "详情",
        "usedIn": "用于"
      },
      "commodities": {
        "index": "商品"
      },
      "components": {
        "index": "部件"
      },
      "blueprints": {
        "index": "蓝图"
      },
      "missions": {
        "index": "任务"
      },
      "missions": {
        "index": "任务"
      },
      "equipment": {
        "index": "装备",
        "metrics": "数据",
        "identity": "详情",
        "craftedFrom": "制造配方"
      }
    }
  }
}
